import React, { FC, PropsWithChildren } from "react";

export const combineComponents = (
  ...components: FC<PropsWithChildren>[]
): FC<PropsWithChildren> =>
  components.reduce<FC<PropsWithChildren>>(
    (AccumulatedComponents, CurrentComponent) =>
      ({ children }: PropsWithChildren): JSX.Element =>
        (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        ),
    ({ children }) => <>{children}</>
  );
